/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function () {
  // Update header cart count badges and strip ".00" / ",00" from the
  // JS-rendered cart drawer total after every Ajax cart change.

  var HEADER_COUNT_SELECTOR = '.count_cartitem_jj[data-cart-items-qty]';
  var TOTAL_PRICE_SELECTOR = '[data-cart-total-price]';
  var FORM_SELECTOR = 'form[data-product-form]';
  var ADD_TO_CART_SELECTOR = '[data-add-to-cart], [data-quick-add], button[name="add"], form[action$="/cart/add"] button[type="submit"]';
  var CART_CHECK_DELAY_MS = 700;
  var CART_FINAL_CHECK_DELAY_MS = 1900;
  var activeCartCheck = null;

  function stripTrailingZeros(text) {
    if (!text) return text;
    // Removes ".00" or ",00" preceding a non-digit boundary (currency, end of string, etc.)
    return text.replace(/([.,])00(?!\d)/g, '');
  }

  function updateHeaderCount(count) {
    var nodes = document.querySelectorAll(HEADER_COUNT_SELECTOR);
    nodes.forEach(function (node) {
      node.textContent = count;
      node.classList.toggle('hidden', count === 0);
    });

    // Mirror has-items state on cart toggle buttons
    document.querySelectorAll('.cart__toggle').forEach(function (btn) {
      btn.classList.toggle('cart__toggle--has-items', count > 0);
    });
  }

  function stripTotalPriceZeros() {
    document.querySelectorAll(TOTAL_PRICE_SELECTOR).forEach(function (node) {
      var stripped = stripTrailingZeros(node.innerHTML);
      if (stripped !== node.innerHTML) node.innerHTML = stripped;
    });
  }

  function refreshFromCart() {
    return fetch(window.Shopify.routes.root + 'cart.js', {
      headers: {Accept: 'application/json'},
      cache: 'no-store',
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateHeaderCount(cart.item_count || 0);
        stripTotalPriceZeros();
        return cart;
      })
      .catch(function () { /* noop */ });
  }

  function isDrawerCartEnabled() {
    return Boolean(window.theme && window.theme.settings && window.theme.settings.cartType === 'drawer');
  }

  function getVisibleCartCount() {
    return Number((document.querySelector(HEADER_COUNT_SELECTOR) || {}).textContent || 0) || 0;
  }

  function openCartDrawerFallback() {
    var cartElement = document.querySelector('cart-element[data-cart-drawer]');
    if (cartElement && typeof cartElement.openCartDrawer === 'function') {
      cartElement.openCartDrawer();
      return;
    }

    // Last-resort visual fallback in case cart-element API is not available.
    var drawer = document.getElementById('cart-drawer');
    if (!drawer) return;
    document.body.classList.add('js-drawer-open-cart');
    drawer.classList.remove('cv-h');
    drawer.classList.add('is-open');
  }

  function openDrawerAfterSuccessfulAdd(previousCount) {
    if (!isDrawerCartEnabled()) return Promise.resolve(false);
    if (document.body.classList.contains('js-drawer-open-cart')) return Promise.resolve(true);

    return refreshFromCart().then(function (cart) {
      if (!cart || typeof cart.item_count !== 'number') return false;
      if (cart.item_count <= previousCount) return false;

      document.dispatchEvent(new CustomEvent('theme:cart:refresh', {bubbles: true}));
      window.setTimeout(openCartDrawerFallback, 120);
      return true;
    });
  }

  function clearActiveCartCheck() {
    if (!activeCartCheck) return;
    window.clearTimeout(activeCartCheck.firstTimeoutId);
    window.clearTimeout(activeCartCheck.finalTimeoutId);
    activeCartCheck = null;
  }

  function startReliableCartOpenCheck(previousCount) {
    if (!isDrawerCartEnabled()) return;
    if (document.body.classList.contains('js-drawer-open-cart')) return;

    clearActiveCartCheck();

    var threshold = Number(previousCount) || 0;
    var resolved = false;
    var running = false;

    var runCheck = function () {
      if (resolved) return;
      if (document.body.classList.contains('js-drawer-open-cart')) return;
      if (running) return;
      running = true;

      if (getVisibleCartCount() > threshold) {
        resolved = true;
        document.dispatchEvent(new CustomEvent('theme:cart:refresh', {bubbles: true}));
        window.setTimeout(openCartDrawerFallback, 120);
        clearActiveCartCheck();
        running = false;
        return;
      }

      openDrawerAfterSuccessfulAdd(threshold).then(function (opened) {
        running = false;
        if (!opened || resolved) return;
        resolved = true;
        clearActiveCartCheck();
      });
    };

    var firstTimeoutId = window.setTimeout(runCheck, CART_CHECK_DELAY_MS);
    var finalTimeoutId = window.setTimeout(runCheck, CART_FINAL_CHECK_DELAY_MS);

    activeCartCheck = {
      firstTimeoutId: firstTimeoutId,
      finalTimeoutId: finalTimeoutId,
    };
  }

  // Retry opening the drawer at staggered intervals. Absorbs iOS Safari
  // first-paint timing variance without piling on calls once the drawer is open.
  function ensureDrawerOpenWithRetries() {
    if (!isDrawerCartEnabled()) return;
    var delays = [50, 200, 500, 1000];
    delays.forEach(function (ms) {
      window.setTimeout(function () {
        if (document.body.classList.contains('js-drawer-open-cart')) return;
        openCartDrawerFallback();
      }, ms);
    });
  }

  // Fires after cart drawer rebuild on add / qty change / remove
  document.addEventListener('theme:cart:added', function () {
    refreshFromCart();
    ensureDrawerOpenWithRetries();
  });

  // Prerender the cart drawer template once on idle so the first Add to Cart
  // doesn't race the template→DOM insertion (iOS Safari first-add bug).
  var prerenderDone = false;
  function prerenderCartDrawer() {
    if (prerenderDone) return;
    if (!isDrawerCartEnabled()) return;
    var el = document.querySelector('cart-element[data-cart-drawer]');
    if (!el || el.isCartDrawerLoaded) { prerenderDone = true; return; }
    if (typeof el.renderCartDrawer !== 'function') return;
    prerenderDone = true;
    try { el.renderCartDrawer(false); } catch (_) {}
  }
  function scheduleEagerPrerender() {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(prerenderCartDrawer, {timeout: 2000});
    } else {
      window.setTimeout(prerenderCartDrawer, 1500);
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleEagerPrerender);
  } else {
    scheduleEagerPrerender();
  }
  // Fires after the cart drawer is first rendered
  document.addEventListener('theme:cart:loaded', refreshFromCart);

  // Qty change / remove inside the cart drawer dispatches these events but
  // does NOT re-fire theme:cart:loaded, so the header badges (which live
  // outside the drawer) get stuck on the previous count. Refresh on every
  // cart mutation. The slight delay lets the server-side update settle so
  // /cart.js returns the new item_count.
  function scheduleHeaderRefresh() {
    window.setTimeout(refreshFromCart, 250);
    window.setTimeout(refreshFromCart, 900);
  }
  document.addEventListener('theme:cart:update', scheduleHeaderRefresh);
  document.addEventListener('theme:cart:refresh', scheduleHeaderRefresh);

  // Belt-and-braces: mirror the drawer's own [data-cart-items-qty] span into
  // the header badges whenever it changes. Catches any in-drawer flow that
  // bypasses the events above.
  function watchDrawerQtyMirror() {
    var drawerQty = document.querySelector('#cart-drawer [data-cart-items-qty], cart-element [data-cart-items-qty]');
    if (!drawerQty || drawerQty.classList.contains('count_cartitem_jj')) return;
    var apply = function () {
      var n = parseInt((drawerQty.textContent || '0').replace(/\D/g, ''), 10) || 0;
      updateHeaderCount(n);
    };
    new MutationObserver(apply).observe(drawerQty, {childList: true, characterData: true, subtree: true});
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchDrawerQtyMirror);
  } else {
    watchDrawerQtyMirror();
  }
  // Re-attach after the drawer is (re)rendered, since the node may be replaced.
  document.addEventListener('theme:cart:loaded', watchDrawerQtyMirror);

  // Fallback: if a native/third-party submit adds to cart without
  // triggering the theme ProductForm flow, refresh and open drawer.
  document.addEventListener('submit', function (event) {
    if (!isDrawerCartEnabled()) return;
    var form = event.target;
    if (!form || !form.matches || !form.matches(FORM_SELECTOR)) return;
    if (document.body.classList.contains('js-drawer-open-cart')) return;
    var currentCount = getVisibleCartCount();

    startReliableCartOpenCheck(currentCount);
  }, true);

  // Additional fallback for pages where add-to-cart is handled via click
  // handlers and no submit event reaches the document.
  document.addEventListener('click', function (event) {
    if (!isDrawerCartEnabled()) return;

    var addToCartButton = event.target && event.target.closest ? event.target.closest(ADD_TO_CART_SELECTOR) : null;
    if (!addToCartButton) return;
    if (addToCartButton.hasAttribute('disabled') || addToCartButton.classList.contains('is-loading')) return;
    if (document.body.classList.contains('js-drawer-open-cart')) return;

    var currentCount = getVisibleCartCount();
    startReliableCartOpenCheck(currentCount);
  }, true);

  // Initial pass on page load (in case JS-rendered checkout total still has .00)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', stripTotalPriceZeros);
  } else {
    stripTotalPriceZeros();
  }
})();